import React from 'react';
import PropTypes from 'prop-types';
import FormInputHOC from './FormInputHOC';

const TextArea = (props) => {
  const handleChange = (e) => {
    // Make the textarea auto-size according to content.
    if (props.autoheight) {
      const node = e.target;
      if (node && node.style) {
        node.style.height = 'auto';
        node.style.height = `${node.scrollHeight}px`;
      }
    }

    props.onChange(props.name,
      e.target.value);
    if (props.validate) {
      props.validate({[props.name]: e.target.value});
    }
  };

  const getProps = () => {
    /* eslint-disable no-unused-vars */
    const {
      onChange,
      validate,
      autoheight,
      value,
      ...properties
    } = props;
    /* eslint-enable no-unused-vars */

    properties.onBlur = handleChange;
    properties.defaultValue = value;

    return properties;
  };

  return <textarea {...getProps()} />;
};

TextArea.PropTypes = {
  autoheight:PropTypes.bool,
  name:PropTypes.string.isRequired,
  onChange:PropTypes.func.isRequired,
  validate:PropTypes.func,
  value:PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default FormInputHOC(TextArea);
